export const {
  REACT_APP_API_ENDPOINT: API_ENDPOINT,
  REACT_APP_OKTA_ISSUER: OKTA_ISSUER,
} = process.env
